import FormBaseModel from '@cp-models/FormBaseModel';
import Profile from '@models/Profile'

export default class User extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'name': 'string',
            'email': 'string',
            'id_profile': 'number',
            'id_company': 'number',
            'username': 'string',
            'profile': Profile
        }
    }

}
